import React, { useContext } from "react"
import Helmet from "react-helmet"

import BannerSection from "../components/BannerSection"
import { TextSection, Button } from "../components/Section"
import BannerContext from "../lib/context"



import VisionImage from '../assets/images/general/177.jpg'
import ChurchGroupPhoto from '../assets/images/church/church-group-photo.jpg'

// import CarolineImage from '../assets/images/team/Caroline.png'





const AboutUs = () => {
    const siteTitle = "Blackheath and Charlton Baptist Church - About Us"
    // const pageData = useLocalData( getStaticPageData, 'about-us-banners', 'about-us-banners' )
    const pageData = useContext( BannerContext )['about-us-banners']
    const { header, banners } = pageData || { header: null, banners: null }
    // const headerImages = useData( getAboutUsHeader )
    // const headerTitle = "About Us"
    const headerImages = header ? header.images : []
    const headerTitle = header ? header.title : 'About Us'
    const headerText = header ? header.text : ''

    const headerIcon = <span className="icon major"><i className="fas fa-users"></i></span>
    const headerButtons = [
        { url: "/about-us/#one", text: "Learn about us" }
    ]

    
    return (
        <div id="about-us-page">
            {/* <Header images={headerImages} headerText={headerText} headerTitle={headerTitle} tint={0.6} headerButtons={headerButtons} /> */}
            <Helmet title={siteTitle} />
{/* 
            <section data-aos="fade-up" id="who-we-are" className="main style1">
                <div className="grid-wrapper">
                    <div className="col-6">
                        <header className="major">
                            <h2>Who We Are</h2>
                        </header>
                        <p><strong>Blackheath and Charlton Baptist Church</strong> is a Christ-centred, 
                        Spirit led multicultural community  rooted in God’s love with a desire for encountering His presence and to see His will be done in our lives. 
                        </p>
                        <p> 
                            We are a welcoming church family with a heart of praise who always endeavours to let the gospel and example of Jesus Christ find 
                            expression our daily lives by showing our love for those we encounter and being a light in this world.
                        </p>
                    </div>
                    <div className="col-6">
                        <span className="image fit"><img src={GroupImage} alt="" /></span>
                    </div>
                </div>
            </section> */}

            <TextSection 
                id="who-we-are"
                style="style1"
                title="Who We Are"
                tint={0.7}
                blur={0}
                description={`<em>BCB Church</em> is Christ-centred and rooted in God's love, with a desire to encounter His presence as we pray and seek His kingdom to come and His will to be done in our lives.

We are a family on an exciting adventure to encounter God's presence and the transforming work of the Holy Spirit, impacting lives by letting the gospel and example of Jesus Christ find expression in our daily lives and being a light in this world.

Join us on this exciting journey, find your place of belonging in our hope-filled family and partner with Jesus Christ.`}
                background={[ ChurchGroupPhoto ]}
                opacity={0.71}
                alt

            />

            {/* <HalfBackgroundSection
                title="Living"
                style="style1 large"
                background={[BibleBG]}
            >
                <p>Text here </p><br/>
                <h4><b>John 10:10</b></h4>
                <p>The thief comes only to steal and kill and destroy; I have come that they may have life, and have it to the full</p>
            </HalfBackgroundSection>

            <HalfBackgroundSection
                title="Loving"
                style="style1 large"
                background={[BibleBG]}
                alt
            >

            </HalfBackgroundSection>


            <HalfBackgroundSection
                title="Equippinig"
                style="style1 large"
                background={[BibleBG]}
            >

            </HalfBackgroundSection>


            <HalfBackgroundSection
                title="Serve"
                style="style1 large"
                background={[BibleBG]}
                alt
            >

            </HalfBackgroundSection> */}



            <TextSection 
                id="what-we-believe"
                style="style1 large"
                title="What We Believe"
                description={`We believe in the one true God, in Jesus Christ our Redeemer and Saviour, and in the manifesting power and gifts of the Holy Spirit.

We believe that God is a holy, just and righteous God and that there is no unrighteousness in Him.

We believe in Jesus Christ as the only Son of God, who by His sacrificial act of love was crucified, died and was raised for the forgiveness of our sins and to reconcile humanity back to God. It is by this love, action and grace that we are saved, and not by human works or effort.

We believe in the infallible and living Word of God, the Holy Bible, by which our faith grows and becomes active as we live righteous and sanctified lives.

We believe in the indwelling, outpouring and continuous renewing work of the Holy Spirit, which manifests God's power through miracles. This is the Spirit of truth, who equips and guides us in fulfilling God's purpose in our lives and His mission here on Earth.`}
                // background={[ BelieveImage2 ]}
                

            />

            <TextSection 
                id="vision"
                style="style1 large"
                title="Vision"
                background={[ VisionImage ]}
                description={`Our church family believes in living our lives as a testimony to Jesus Christ by living life to its fullest and loving one another as Christ loves us. We are committed to equipping and empowering others with the Word of God to live transformative and faith- filled lives and to offering our lives in service to those in need within our church, both locally and globally.`}
                
                tint={0.6}

            />

             <TextSection 
                id="membership"
                style="style1 blue"
                title="Church Membership"
                // background={[ VisionImage ]}
                buttons={[ { url: "https://www.baptist.org.uk/Publisher/File.aspx?ID=168463&view=browser", text: "Learn More", special: true } ]}
                description={`Church membership is making a lateral covenant with the local church and committing to its life and mission. Members share together in worship, fellowship, prayer, and service, and, in keeping with the Baptist tradition, take part in the prayerful decision-making of the church community.`}
                tint={0.6}

            />
            
            <section data-aos="fade-up" id="our-team" className="main style1 large special">
                    <div className="col-12">
                        <header className="major">
                            <h2>Our Team</h2>
                        </header>
                    </div>

                    <div className="col-12">
                        <p>
                            {/* Our core Leadership Team has spiritual and legal over consists of the Pastor,
                            elders and members of the */}
                            Our core Leadership Team consists of dedicated individuals who provide spiritual guidance, vision, 
                            and care for our community. United by a shared passion for serving God and others,
                             they work together to lead with integrity, support the church family, and help people grow in faith and purpose.
                        </p>
                    </div>
                    <ul className="actions uniform">

                        <Button url="/our-team" text="Team Members" style={'blue'} />
                    </ul>
                    
                    {/* <div className='team-section'>
                        <div className="team-member">
                            <span className="image fit rounded"><img src={PastorAfiImage} alt="" /></span>
                            <h3>Rev. Afi Kirk</h3>
                            <p><strong>Minister</strong></p>
                        </div>
                        <div className="team-member">
                            <span className="image fit rounded"><img src={CarolineImage} alt="" /></span>
                            <h3>Caroline Ntinyari</h3>
                            <p><strong>Pastoral Team Coordinator</strong></p>
                        </div>
                        <div className="team-member">
                            <span className="image fit rounded"><img  src={OlasumboYatesImage} alt="" /></span>
                            <h3>Olasumbo Yates</h3>
                            <p><strong>Deacon</strong></p>
                        </div>
                        <div className="team-member">
                            <span className="image fit rounded"><img src={PaulineMaslineImage} alt="" /></span>
                            <h3>Pauline Maslin</h3>
                            <p><strong>Deacon</strong></p>
                        </div>
                        <div className="team-member">
                            <span className="image fit rounded"><img  src={YaaOwusuaImage} alt="" /></span>
                            <h3>Yaa Owusua</h3>
                            <p><strong>Deacon</strong></p>
                        </div>
                    </div> */}
            </section>


{/* 
            <section data-aos="fade-up" id="our-team" className="main style1 special">
                <div className="grid-wrapper">
                    <div className="col-12">
                        <header className="major">
                            <h2>Our Team</h2>
                        </header>
                    </div>
                    
                    <div className="col-4">
                        <span className="image fit rounded"><img src={BlankProfileImage} alt="" /></span>
                        <h3>Rev. Afi Kirk</h3>
                        <p><strong>Minister</strong></p>
                    </div>
                    <div className="col-4">
                        <span className="image fit rounded"><img src={BlankProfileImage} alt="" /></span>
                        <h3>Tunde Omotosho</h3>
                        <p><strong>Treasurer</strong></p>
                    </div>
                    <div className="col-4">
                        <span className="image fit rounded"><img src={BlankProfileImage} alt="" /></span>
                        <h3>Juan Erazo</h3>
                        <p><strong>Deacon</strong></p>
                    </div>
                    <div className="col-4">
                        <span className="image fit rounded"><img src={BlankProfileImage} alt="" /></span>
                        <h3>Pauline Maslin</h3>
                        <p><strong>Deacon</strong></p>
                    </div>
                    <div className="col-4">
                        <span className="image fit rounded"><img src={BlankProfileImage} alt="" /></span>
                        <h3>Marvella Francis</h3>
                        <p><strong>Deacon</strong></p>
                    </div>
                    

                </div>
            </section> */}

            <BannerSection banners={banners} />
        </div>
    )
}

export default AboutUs